import type { AxiosResponse } from 'axios';
import type { ListParams, PaginatedData, ApiSuccessResponse } from '@/shared/types';

/**
 * Build query params for paginated list endpoints.
 * Strips undefined / null / empty-string values.
 */
export function buildListParams(params: ListParams): Record<string, unknown> {
  const { page = 0, size = 20, sort, ...filters } = params;
  const result: Record<string, unknown> = { page, size };

  if (sort?.length) result.sort = sort;

  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      result[key] = value;
    }
  });

  return result;
}

/**
 * Extract paginated data from a standard API response.
 */
export function extractPaginatedData<T>(
  response: AxiosResponse<ApiSuccessResponse<PaginatedData<T>>>,
): PaginatedData<T> {
  const data = response.data?.data;
  return {
    content: data?.content ?? [],
    currentPage: data?.currentPage ?? 0,
    totalItems: data?.totalItems ?? 0,
    totalPages: data?.totalPages ?? 0,
    pageSize: data?.pageSize ?? 20,
  };
}
